import Form from 'react-bootstrap/Form';
import { FilterValue } from 'components/filtering/types/FilterObject';



interface FilterResultItemProps {
	filterValue: FilterValue,
	onToggle: (checkedValues: unknown[]) => void,
}


const FilterResultItem = (props: FilterResultItemProps) => {
	const { filterValue, onToggle } = props;

	return (
		<div className='popover-filter-result-item' onClick={() => onToggle([ filterValue.value ])}>
			
			<Form.Check
				type="checkbox"
				className="app-form-checkbox"
				checked={filterValue.checked}
				onChange={() => {}} />

			<p>{filterValue.value ? String(filterValue.value) : '(Prázdné)'}</p>

		</div>
	);
};

export default FilterResultItem;